<template>
  <section>
    <Feature :title="$t('CPC_HIGH_PRICE_MAINTAIN')" :iconClass="'fa-handshake-o'">
      <FormRowTwo :fieldNameArr="[$t('STATUS') + ': ', $t('DELTA_PN') + ': ', $t('VENDOR_CODE') + ': ', $t('PLANT') + ': ']"
        :fieldWidthArr="[362, 362, 372, 362]" :fieldSpanWidthArr="[100, 100, 105, 100]">
        <Select class="Select" v-model="status" slot="a">
          <Option v-for="(item, index) in statusList" :value="item.description" :key="index">{{ item.description }}
          </Option>
        </Select>
        <Input class="Input" v-model="deltaPn" search :enter-button="$t('MORE')" @on-search="moreDeltaPn" slot="b" />
        <Input class="Input" v-model="vnCode" search :enter-button="$t('MORE')" @on-search="moreVnCode" slot="c" />
        <Input class="Input" v-model="plant" search :enter-button="$t('MORE')" @on-search="morePlant" slot="d" />
      </FormRowTwo>
      <FormRowTwo :fieldNameArr="[$t('APPLY_DATE')  + ': ', '~']"
        :fieldWidthArr="[362, 282, 412]" :fieldSpanWidthArr="[100, 20, 150]">
        <DatePicker class="Input" v-model="fromRfqDate" type="date" format="yyyy-MM-dd" slot="a">
        </DatePicker>
        <DatePicker class="Input" v-model="toRfqDate" type="date" format="yyyy-MM-dd" slot="b">
        </DatePicker>
      </FormRowTwo>
      <ButtonRow>
        <Button type="success" @click="search($event, true)" slot="0">{{ $t('COMMON_TEXT_SEARCH') }}</Button>
        <Button type="info" @click="clear" slot="1">{{ $t('CLEAR') }}</Button>
      </ButtonRow>
      <Collapse :accordion="true" v-model="batchCollapse">
        <Panel name="1">
          {{ $t("LABEL_TEXT_BATCH_EDIT") }}
          <Form label-position="right" :inline="true" slot="content">
            <FormItem :label="$t('COMMENTS')" :label-width="100">
              <Icon type="ios-create" size="28" class="text-delta-blue" @click="showBatchCommentsModal" />
            </FormItem>
            <FormItem :label="$t('BG')" :label-width="60">
              <Select class="select-small mr-10" v-model="batchBg">
                <Option v-for="(item, index) in batchBgList" :value="item" :key="index">{{ item }}</Option>
              </Select>
            </FormItem>
            <FormItem :label="$t('BU')" :label-width="60">
              <Select class="select-small" v-model="batchBu">
                <Option v-for="(item, index) in batchBgBuMap[batchBg]" :value="item" :key="index">{{ item }}</Option>
              </Select>
            </FormItem>
            <FormItem :label="$t('HIGH_PRICE_REASON_CATEGORY')" :label-width="200">
              <Select class="select-small" v-model="batchHighPriceReasonCategory">
                <Option v-for="(item, index) in batchHighPriceReasonCategoryList" :value="item.highPriceReasonCategory" :key="index">{{ item.highPriceReasonCategory }}</Option>
              </Select>
            </FormItem>
            <FormItem label="" :label-width="20">
              <Button class="button" type="info" @click="showBatchApproveFileModal">{{ $t("APPROVE_REFERENCE_FILE_UPLOAD") }}</Button>
            </FormItem>
            <br/>
            <FormItem label="" :label-width="20">
              <Button type="success" @click="batchApprove()">{{ $t('APPROVE') }}</Button>
            </FormItem>
            <FormItem label="" :label-width="20">
              <Button type="error" @click="batchDelete()">{{ $t('DELETE') }}</Button>
            </FormItem>
          </Form>
        </Panel>
      </Collapse>
      <FormRowTwo :fieldNameArr="[$t('SELECT_ALL') + ': ', '']" :fieldWidthArr="[290]" :fieldSpanWidthArr="[100]">
        <RadioGroup v-model="selectAllType" size="large" slot="a">
          <Radio label="APPROVE">{{ $t('APPROVE') }}</Radio>
          <Radio label="DELETE">{{ $t('DELETE') }}</Radio>
        </RadioGroup>
        <Button type="info" @click="cleanSelectAllType" slot="b">{{ $t('CLEAR_SELECT') }}</Button>
      </FormRowTwo>
      <FormRowTwo :fieldNameArr="[$t('HIGH_PRICE') + ': ', $t('HIGH_PRICE_REASON_CATEGORY'), '']" :fieldWidthArr="[425, 360]" :fieldSpanWidthArr="[100, 210]">
        <span slot="a" class="mr-10">BG</span>
        <Select class="select-small mr-10" v-model="bg" slot="a">
          <Option v-for="(item, index) in bgList" :value="item" :key="index">{{ item }}
          </Option>
        </Select>
        <span slot="a" class="mr-10">BU</span>
        <Select class="select-small" v-model="bu" slot="a">
          <Option v-for="(item, index) in bgbuMap[bg]" :value="item" :key="index">{{ item }}
          </Option>
        </Select>
        <Select class="select-small" v-model="highPriceReasonCategory" slot="b">
          <Option v-for="(item, index) in highPriceReasonCategoryList" :value="item.highPriceReasonCategory" :key="index">{{ item.highPriceReasonCategory }}
          </Option>
        </Select>
        <Button class="button" type="info" @click="openApproveFileModal" slot="c">{{ $t("APPROVE_REFERENCE_FILE_UPLOAD") }}</Button>
      </FormRowTwo>

      <div style="margin: 15px;">
      <TablePage class="highPriceTable" :tableWidth="windowWidth" v-show="quotationView" :columnsList="quotationColumnList"
      :resultList="quotationList" :pageObj="pageObj" @changePage="changePage" :searchBar="false"></TablePage>
      </div>
      <ButtonRow v-if="getCpcHighPriceStatus() == 'Waiting CPC'">
        <Button type="primary" @click="handleSubmit" slot="1">{{ $t('SUBMIT') }}</Button>
      </ButtonRow>
    </Feature>

    <Modal
      :z-index="modalSize"
      :reset-drag-position="true"
      sticky
      :draggable="true"
      width="900"
      v-model="batchCommentsModal"
      :title="$t('COMMENTS')"
    >
      <froala :config="FloraEditorConfig" v-model="batchComments"></froala>
    </Modal>
    <Modal 
      :z-index="modalSize" 
      :reset-drag-position="true" 
      sticky 
      :draggable="true" 
      width="900" 
      v-model="batchApproveFileModal" 
      :title="$t('APPROVE_REFERENCE_FILE_UPLOAD')"
    >
      <FormRow :fieldNameArr="['*' + $t('QUOTATION_FILE_UPLOAD') + '(' + $t('FILE_SIZE_LESS_THAN_5MB') + ')', file == null ? '' : file.name]">
        <Upload slot="a" :before-upload="handleTableUpload" action="*">
          <Button icon="ios-cloud-upload">{{ $t("UPLOAD") }}</Button>
        </Upload>
        <Button type="primary" v-show="file !== null" slot="b" @click="batchUploadFile(false)">{{ $t("CLICK_UPLOAD") }}</Button>
      </FormRow>
      <FormRow v-if="showBatchApproveReferenceFile" :fieldNameArr="['']">
        <Table width="600" border :columns="fileSchemaList" :data="showBatchApproveReferenceFile" slot="a">
          <template slot-scope="{ row }" slot="action">
            <Button type="primary" shape="circle" icon="md-download" @click="tableDownloadReferenceFile(row)"></Button>
            <Button type="error" shape="circle" icon="md-close-circle" @click="deleteBatchApproveReferenceFile(row)"></Button>
          </template>
        </Table>
      </FormRow>
    </Modal>

    <!-- Delta PN Modal -->
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" v-model="deltaPnModel"
      :title="$t('DELTA_PN_MORE')" @on-ok="confirmDeltaPnValue">
      <Input v-model="deltaPnValue" type="textarea" :rows="10" />
    </Modal>
    <!-- Vendor Code Modal -->
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" v-model="vnCodeModel"
      :title="$t('VENDOR_CODE_MORE')" @on-ok="confirmVnCodeValue">
      <Input v-model="vnCodeValue" type="textarea" :rows="10" />
    </Modal>
    <!-- Plant Code Modal -->
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" v-model="plantModel"
      :title="$t('VENDOR_CODE_MORE')" @on-ok="confirmPlantValue">
      <Input v-model="plantValue" type="textarea" :rows="10" />
    </Modal>

    <!-- 批次 Approve Ref Upload Modal -->
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="approveReferenceFileModel" :title="$t('APPROVE') + ' ' + $t('REFERENCE_FILE')">
      <FormRow
        :fieldNameArr="['*' + $t('QUOTATION_FILE_UPLOAD') + '(' + $t('FILE_SIZE_LESS_THAN_5MB') + ')', file == null ? '' : file.name]">
        <Upload slot="a" :before-upload="handleTableUpload" action="*">
          <Button icon="ios-cloud-upload">{{ $t('UPLOAD') }}</Button>
        </Upload>
        <Button type="primary" v-show="file !== null" slot="b" @click="uploadFile(false)">{{
          $t('CLICK_UPLOAD') }}</Button>
      </FormRow>
      <FormRow v-if="showApproveReferenceFile" :fieldNameArr="['']">
        <Table width="600" border :columns="fileSchemaList" :data="showApproveReferenceFile" slot="a">
          <template slot-scope="{ row }" slot="action">
            <Button type="primary" shape="circle" icon="md-download" @click="tableDownloadReferenceFile(row)"></Button>
            <Button type="error" shape="circle" icon="md-close-circle"
              @click="deleteApproveReferenceFile(row)"></Button>
          </template>
        </Table>
      </FormRow>
    </Modal>

    <!-- Table Comments -->
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" 
      v-model="tableCommentModel" :title="$t('COMMENTS')" @on-ok="confirmTableComments">
      <!-- <froala :config="FloraEditorConfig" v-model="tableComment"></froala> -->
      <froala :config="FloraEditorConfig" v-model="tableCurrItem.comments"></froala>
    </Modal>
    <!-- Table History Comments -->
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
      v-model="tableHistoryCommentModel" :title="$t('HISTORY_COMMENTS')">
      <froala :config="FloraEditorConfig" v-model="tableHistoryComment"></froala>
    </Modal>
    <!-- Table Info Record -->
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
      v-model="tableInfoRecordModel" :title="$t('INFO_RECORD')" @on-ok="confirmTableInfoRecord">
      <InfoRecordMaintain v-if="tableInfoRecordModel" :quotation="tableCurrItem.cpcHighPriceInfoRecordDto" :materialTypeList="materialTypeList" :readonly="true"></InfoRecordMaintain>
    </Modal>
    <!-- Table Log -->
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
      v-model="tableLogModel" :title="$t('LOG')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <TablePage :columnsList="tableLogColumnList" :resultList="tableLogList" :tableMaxHeight="800"></TablePage>
      </div>
    </Modal>
    <!-- Table Quotation File -->
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
      v-model="tableQuotationFileModel" :title="$t('QUOTATION_FILE')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <FileDocument :attachments="tableQuotationFile"></FileDocument>
      </div>
      <!-- <froala :config="FloraEditorConfig" v-model="tableQuotationFile"></froala> -->
    </Modal>
    <!-- Table Reference File -->
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
      v-model="tableReferenceFileModel" :title="$t('APPROVE') + ' ' + $t('REFERENCE_FILE')">
      <!-- <froala :config="FloraEditorConfig" v-model="tableReferenceFile"></froala> -->
      <FormRow
        :fieldNameArr="['*' + $t('QUOTATION_FILE_UPLOAD') + '(' + $t('FILE_SIZE_LESS_THAN_5MB') + ')', file == null ? '' : file.name]">
        <Upload slot="a" :before-upload="handleTableUpload" action="*">
          <Button icon="ios-cloud-upload">{{ $t('UPLOAD') }}</Button>
        </Upload>
        <Button type="primary" v-show="file !== null" slot="b" @click="uploadFile(tableCurrItem.uuid)">{{
          $t('CLICK_UPLOAD') }}</Button>
      </FormRow>
      <FormRow v-if="tableReferenceFile.length > 0" :fieldNameArr="['']">
        <Table width="600" border :columns="fileSchemaList" :data="tableReferenceFile" slot="a">
          <template slot-scope="{ row }" slot="action">
            <Button type="primary" shape="circle" icon="md-download"
              @click="tableDownloadReferenceFile(row)"></Button>
            <Button type="error" shape="circle" icon="md-close-circle"
              @click="tableDeleteReferenceFile(row)"></Button>
          </template>
        </Table>
      </FormRow>
    </Modal>
    <!-- Log Comments Dialog -->
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
      v-model="flowCommentModel" :title="$t('COMMENTS')">
      <froala :config="FloraEditorConfig" v-model="flowComment"></froala>
    </Modal>

  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { AlertInfo, AlertError } from "@/util/alert"
import FileDocument from '@/components/FileDocument.vue'
import { Translate, FloraEditorConfig } from "@/util/common"
import moment from "moment"
import FormRowTwo from '@/components/FormRowTwo'

import { FileSchemaList } from "@/util/tableTitle"
import InfoRecordMaintain from "@/views/quotation/InfoRecordMaintain"


export default {
  name: "CpcMaintain",
  components: {
    FormRowTwo,
    FileDocument,
    InfoRecordMaintain
  },
  inject: ['reload'],
  created() {
    const vueInstance = this //high-price-maintain
    // call status option
    vueInstance.$queryStatusList(vueInstance, 'cpc/high-price-maintain').then(data => {
      if (data) {
        vueInstance.statusList = data;
        if (vueInstance.getCpcHighPriceStatus() == "") {
          vueInstance.setCpcHighPriceStatus(vueInstance.statusList[0].description)
          vueInstance.setCpcHighPriceStatusEnum(vueInstance.statusList[0])
        }
        vueInstance.search(true)
      } else {
        AlertInfo(vueInstance, vueInstance.$t('COMMON_MESSAGE_NOT_AUTH')).then(() => {
        })
        vueInstance.$router.push("/home")
      }
    });

    // call bubg
    vueInstance.$queryHighPriceBgBu(vueInstance, 'bgBuMap').then(data => {
      console.log(data);
      if (data) {
        vueInstance.bgbuMap = data;
        vueInstance.bgList = Object.keys(data);
        vueInstance.batchBgBuMap = data;
        vueInstance.batchBgList = Object.keys(data);
      } else {
        AlertInfo(vueInstance, vueInstance.$t('COMMON_MESSAGE_NOT_AUTH')).then(() => {
        })
        vueInstance.$router.push("/home")
      }
    });

    // call high price category option
    vueInstance.$queryHighPriceReasonCategory(vueInstance).then(data => {
      if (data) {
        vueInstance.highPriceReasonCategoryList = data;
        vueInstance.batchHighPriceReasonCategoryList = data;
      } else {
        AlertInfo(vueInstance, vueInstance.$t('COMMON_MESSAGE_NOT_AUTH')).then(() => {
        })
        vueInstance.$router.push("/home")
      }
    });
    // call info record material type option
    vueInstance.$quotationHttp
      .get("/quotation/material-type")
      .then(response => {
        if (response.data) {
          vueInstance.materialTypeList = response.data;
        }
    });
  },
  data() {
    return {
      batchCollapse: "1",
      statusList: [],
      deltaPnModel: false, // deltaPn More Model control
      deltaPnValue: '', // deltaPn More Model data
      vnCodeModel: false, // Vendor Code More Model control
      vnCodeValue: '', // Vendor Code More Model data
      plantModel: false,
      plantValue: '',
      fileSchemaList: FileSchemaList(this),
      file: null, // 檔案上傳
      // 批次條件
      selectAllType: '',
      bgbuMap: {},
      bg: '',
      bgList: [],
      bu: '',
      highPriceReasonCategory: '',
      highPriceReasonCategoryList: [],
      approveReferenceFile: [],
      approveReferenceFileModel: false,

      FloraEditorConfig: FloraEditorConfig(""),
      
      // Table
      tableCurrItem: {},
      // tableComment: '', // 用 tableCurrItem 取代
      tableCommentModel: false,
      tableHistoryComment: '',
      tableHistoryCommentModel: false,
      // tableInfoRecord: '', // 用 tableCurrItem 取代
      tableInfoRecordModel: false,
      // tableLog: '',
      tableLogList: [],
      tableLogModel: false,
      tableQuotationFile: [],
      tableQuotationFileModel: false,
      tableReferenceFile: [],
      tableReferenceFileModel: false,
      materialTypeList: [],

      flowCommentModel: false,
      flowComment: '',

      quotationList: [],
      pageObj: {
        "page": 0,
        "totalPage": 0,
        "totalCount": 0,
        "pageSize": 100
      },
      batchComments: "",
      batchCommentsModal: false,
      batchBg: "",
      batchBgList: [],
      batchBu: "",
      batchBgBuMap: {},
      batchHighPriceReasonCategory: "",
      batchHighPriceReasonCategoryList: [],
      batchApproveFileModal: false,
      batchApproveReferenceFile: []
    }
  },
  methods: {
    showBatchCommentsModal() {
      this.batchCommentsModal = true;
    },
    showBatchApproveFileModal() {
      this.batchApproveFileModal = true;
    },
    changePage(page) {
      this.pageObj.page = page - 1
      this.search(false)
    },
    ...mapGetters(["getCpcHighPriceStatus", "getCpcHighPriceDeltaPn", "getCpcHighPriceVendorCode",
      "getCpcHighPriceFromRfqDate", "getCpcHighPriceToRfqDate", "getModalSize", "getWindowsWidth", "getCpcHighPricePlant"]),
    ...mapActions(["toggleLoading", "setCpcHighPriceStatus", "setCpcHighPriceStatusEnum", "setCpcHighPriceDeltaPn", "setCpcHighPriceVendorCode",
      "setCpcHighPriceFromRfqDate", "setCpcHighPriceToRfqDate", "setCpcHighPricePlant"]),
    moreDeltaPn() {
      this.deltaPnModel = true
      this.setCpcHighPriceDeltaPn("")
    },
    confirmDeltaPnValue() {
      this.deltaPnValue.split('\n').forEach(a => {
        this.setCpcHighPriceDeltaPn(this.getCpcHighPriceDeltaPn().concat(a.trim() + ";"))
      })
      this.setCpcHighPriceDeltaPn(this.getCpcHighPriceDeltaPn().substr(0, this.getCpcHighPriceDeltaPn().length - 1))
    },

    moreVnCode() {
      this.vnCodeModel = true
      this.setCpcHighPriceVendorCode("")
    },
    confirmVnCodeValue() {
      this.vnCodeValue.split('\n').forEach(a => {
        this.setCpcHighPriceVendorCode(this.getCpcHighPriceVendorCode().concat(a.trim() + ";"))
      })
      this.setCpcHighPriceVendorCode(this.getCpcHighPriceVendorCode().substr(0, this.getCpcHighPriceVendorCode().length - 1))
    },

    morePlant() {
      this.plantModel = true
      this.setCpcHighPricePlant("")
    },
    confirmPlantValue() {
      this.plantValue.split('\n').forEach(a => {
        this.setCpcHighPricePlant(this.getCpcHighPricePlant().concat(a.trim() + ";"))
      })
      this.setCpcHighPricePlant(this.getCpcHighPricePlant().substr(0, this.getCpcHighPricePlant().length - 1))
    },

    cleanSelectAllType () {
      this.selectAllType = ""
    },
    openApproveFileModal() {
      this.file = null;
      this.approveReferenceFileModel = true;
    },
    handleTableUpload(file) {
      this.file = file;
      return false;
    },
    deleteBatchApproveReferenceFile(row) {
      const vueInstance = this;
      vueInstance.batchApproveReferenceFile.forEach(attachment => {
        if (attachment.id === row.id) {
          vueInstance.$set(attachment, "deleted", true);
        }
      })
    },
    deleteApproveReferenceFile(row) {
      const vueInstance = this; 
      // 刪除批次
      vueInstance.approveReferenceFile.forEach(attachment => {
        if (attachment.id == row.id) {
          // attachment.deleted = true;
          vueInstance.$set(attachment, 'deleted', true);
        }
      })
      // 逐一刪除
      vueInstance.quotationList.forEach(quotation => {
        quotation.approveReferenceFile && quotation.approveReferenceFile.forEach(attachment => {
          if (attachment.id == row.id) {
            attachment.deleted = true;
          }
        })
      })
    },
    tableDownloadReferenceFile(row) {
      this.$downloadAttachment(this, row.id)
    },
    tableDeleteReferenceFile(row) {
      let temp;
      this.quotationList.forEach(quotation => {
        if (quotation.uuid == this.tableCurrItem.uuid) {
          temp = quotation;
          quotation.approveReferenceFile && quotation.approveReferenceFile.forEach(attachment => {
            if (attachment.id == row.id) {
              attachment.deleted = true;
            }
          })
        }
      })
      this.tableReferenceFile = temp.approveReferenceFile.filter(attachment => !attachment.deleted);
    },
      
    search(init) {
      const vueInstance = this
      if (!this.getCpcHighPriceStatus()) {
        AlertInfo(this, this.$t('COMMON_MESSAGE_NOT_AUTH')).then(() => {
        })
        this.$router.push("/home")
      } else {
        if (init) {
          vueInstance.pageObj = {
            "page": 0,
            "totalPage": 0,
            "totalCount": 0,
            "pageSize": 100
          }
        }
        vueInstance.clearBatch();
        vueInstance.quotationList = []
        let queryData = buildCriteria(vueInstance)
        try {
          const queryQuotationMaster = query(vueInstance, queryData)
          vueInstance.toggleLoading(true)
          Promise.all([queryQuotationMaster]).then(dataList => {
            let noData = true
            let data = dataList[0];
            
            if (data && data._embedded) {
              noData = false
              if (data._embedded.cpcHighPriceQuotationSearchResourceList) {
                vueInstance.quotationList = vueInstance.addEditableAttr(data._embedded.cpcHighPriceQuotationSearchResourceList);
                console.log('資料');
                console.log(vueInstance.quotationList);
                vueInstance.pageObj = {
                  "page": data.page.number + 1,
                  "totalPage": data.page.totalPages,
                  "totalCount": data.page.totalElements,
                  "pageSize": data.page.size
                }
              }
            }  
            if (noData) {
              vueInstance.$Notice.success({
                title: Translate("COMMON_MESSAGE_INFO"),
                desc: Translate("COMMON_MESSAGE_INFO"),
                render: h => {
                  return h('span', [
                    Translate("COMMON_TEXT_NOTHING")
                  ])
                }
              });
            }
            
            vueInstance.toggleLoading(false)
          })
        } catch (error) {
          vueInstance.toggleLoading(false)
        }
      }
    },
    clear() {
      this.setCpcHighPriceStatus(this.statusList[0].description);
      this.setCpcHighPriceStatusEnum(this.statusList[0]);
      this.setCpcHighPriceDeltaPn('');
      this.setCpcHighPriceFromRfqDate('');
      this.setCpcHighPriceToRfqDate('');
      this.setCpcHighPriceVendorCode('');
      this.setCpcHighPricePlant('');
      this.deltaPnValue = '';
      this.vendorPnValue = '';
      this.vnCodeValue = '';
    },
    clearBatch() {
      this.cleanSelectAllType();
      this.bg = '';
      this.bu = '';
      this.highPriceReasonCategory = '';
      this.approveReferenceFile = [];
    },
    confirmTableComments() {
      const vueInstance = this;
      vueInstance.quotationList.forEach(temp => {
        if (temp.uuid == vueInstance.tableCurrItem.uuid) {
          temp.comments = vueInstance.tableCurrItem.comments;
        } 
        else if (vueInstance.tableCurrItem.action == temp.action) {
          temp.comments = vueInstance.tableCurrItem.comments;
        }
        else if (!temp.comments) {
          temp.comments = '';
        }
      });
      vueInstance.tableCurrItem = {};
    },
    confirmTableInfoRecord() {
      const vueInstance = this;
      vueInstance.quotationList.forEach(temp => {
        if (temp.uuid == vueInstance.tableCurrItem.uuid) {
          temp.cpcHighPriceInfoRecordDto = vueInstance.tableCurrItem.cpcHighPriceInfoRecordDto;
        }
      });
      vueInstance.tableCurrItem = {};
    },
    batchUploadFile() {
      const vueInstance = this;
      let fd = new FormData();
      fd.append('file', vueInstance.file);
      fd.append('description', "quotaion attachement");
      vueInstance.toggleLoading(true);
      vueInstance.$fileHttp
        .post("/attachment/upload-single?description=cpcHighPriceCheck", fd)
        .then(response => {
          vueInstance.batchApproveReferenceFile.push(response.data);
          vueInstance.file = null;
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          vueInstance.toggleLoading(false);
        });
    },
    uploadFile(uuid) {
      let fd = new FormData()
      fd.append('file', this.file)
      fd.append('description', "quotaion attachement")
      this.toggleLoading(true)
      this.$fileHttp
        .post("/attachment/upload-single?description=cpcHighPriceCheck", fd)
        .then((response) => {
          this.toggleLoading(false)
          if (uuid) { // 表格單筆資料上傳檔案
            this.tableReferenceFile.push(response.data);
            this.quotationList.forEach(quotation => {
              if (quotation.uuid == uuid) {
                if (!quotation.approveReferenceFile) {
                  quotation.approveReferenceFile = []
                }
                quotation.approveReferenceFile.push(response.data)
              }
            })
          }
          else { // 批次修改上傳檔案
            this.approveReferenceFile.push(response.data);
            this.quotationList.forEach(quotation => {
              if (!quotation.approveReferenceFile) {
                quotation.approveReferenceFile = []
              }
              quotation.approveReferenceFile.push(response.data)
            })
          }
          this.file = null
          this.toggleLoading(false)
          console.log(this.quotationList);
          console.log(this.approveReferenceFile)
        })
        .catch(() => { })
    },
    dataIsEdit(item) { // 判斷資料是否可編輯
      if (item.erpHighPrice === false && item.bg && item.bg.length > 0) return false;
      if (item.erpHighPrice === true) return true;
      if (item.erpHighPrice === false && (!item.bg)) return true;
    },
    addEditableAttr(dataList) {
      if (dataList && dataList.length > 0) {
        dataList.forEach(data => {
          data.editable = this.dataIsEdit(data);
        });
      }
      return dataList;
    },
    batchApprove() {
      const vueInstance = this;
      let errorMessageArray = [];
      if (vueInstance.batchBg === undefined || vueInstance.batchBg === "") {
        errorMessageArray.push(vueInstance.$t("BG") + vueInstance.$t("IS_REQUIRED"));
      }
      if (vueInstance.batchBu === undefined || vueInstance.batchBu === "") {
        errorMessageArray.push(vueInstance.$t("BU") + vueInstance.$t("IS_REQUIRED"));
      }
      if (vueInstance.batchHighPriceReasonCategory === undefined || vueInstance.batchHighPriceReasonCategory === "") {
        errorMessageArray.push(vueInstance.$t("HIGH_PRICE_REASON_CATEGORY") + vueInstance.$t("IS_REQUIRED"));
      }
      if (errorMessageArray.length > 0) {
        AlertInfo(vueInstance, errorMessageArray.join("<br/>"))
          .then(() => {});
        return;
      }
      let requestBody = {
        status: vueInstance.statusList.find(status => status.description == vueInstance.getCpcHighPriceStatus())['statusViewEnum'],
        deltaPartNos: vueInstance.getCpcHighPriceDeltaPn() === "" ? [] : vueInstance.getCpcHighPriceDeltaPn().split(";"),
        vendorCodes: vueInstance.getCpcHighPriceVendorCode() === "" ? [] : vueInstance.getCpcHighPriceVendorCode().split(";"),
        plantNos: vueInstance.getCpcHighPricePlant() === "" ? [] : vueInstance.getCpcHighPricePlant().split(";"),
        fromRfqDate: vueInstance.getCpcHighPriceFromRfqDate() === "" ? null : moment(vueInstance.getCpcHighPriceFromRfqDate()).format("YYYY-MM-DD"),
        toRfqDate: vueInstance.getCpcHighPriceToRfqDate() === "" ? null : moment(vueInstance.getCpcHighPriceToRfqDate()).format("YYYY-MM-DD"),
        comments: vueInstance.batchComments,
        highPriceReasonCategory: vueInstance.batchHighPriceReasonCategory,
        bg: vueInstance.batchBg,
        bu: vueInstance.batchBu,
        cpcToSupervisorAttachments: vueInstance.batchApproveReferenceFile
      };
      vueInstance.toggleLoading(true);
      vueInstance.$quotationHttp
        .post("/cpc/highPrice/batchApprove", requestBody)
        .then(repsonse => {
          AlertInfo(vueInstance, vueInstance.$t("TEXT_EXECUTION_IN_BACKGROUND"))
            .then(() => {
              vueInstance.clear();
              vueInstance.reload();
            });
        })
        .catch((error) => {
          console.error(error);
          AlertError(vueInstance, error)
            .then(() => {});
        })
        .finally(() => {
          vueInstance.toggleLoading(false);
        });
    },
    batchDelete() {
      const vueInstance = this;
      let errorMessageArray = [];
      if (vueInstance.batchComments === undefined || vueInstance.batchComments === "") {
        errorMessageArray.push(vueInstance.$t("COMMENTS") + vueInstance.$t("IS_REQUIRED"));
      }
      if (errorMessageArray.length > 0) {
        AlertInfo(vueInstance, errorMessageArray.join("<br/>"))
          .then(() => {});
        return;
      }
      let requestBody = {
        status: vueInstance.statusList.find(status => status.description == vueInstance.getCpcHighPriceStatus())['statusViewEnum'],
        deltaPartNos: vueInstance.getCpcHighPriceDeltaPn() === "" ? [] : vueInstance.getCpcHighPriceDeltaPn().split(";"),
        vendorCodes: vueInstance.getCpcHighPriceVendorCode() === "" ? [] : vueInstance.getCpcHighPriceVendorCode().split(";"),
        plantNos: vueInstance.getCpcHighPricePlant() === "" ? [] : vueInstance.getCpcHighPricePlant().split(";"),
        fromRfqDate: vueInstance.getCpcHighPriceFromRfqDate() === "" ? null : moment(vueInstance.getCpcHighPriceFromRfqDate()).format("YYYY-MM-DD"),
        toRfqDate: vueInstance.getCpcHighPriceToRfqDate() === "" ? null : moment(vueInstance.getCpcHighPriceToRfqDate()).format("YYYY-MM-DD"),
        comments: vueInstance.batchComments
      };
      vueInstance.toggleLoading(true);
      vueInstance.$quotationHttp
        .post("/cpc/highPrice/batchDelete", requestBody)
        .then(repsonse => {
          AlertInfo(vueInstance, vueInstance.$t("TEXT_EXECUTION_IN_BACKGROUND"))
            .then(() => {
              vueInstance.clear();
              vueInstance.reload();
            });
        })
        .catch((error) => {
          console.error(error);
          AlertError(vueInstance, error)
            .then(() => {});
        })
        .finally(() => {
          vueInstance.toggleLoading(false);
        });
    },
    handleSubmit() {
      let vueInstance = this;
      let approveData = [], deleteData = [];
      vueInstance.quotationList.forEach(quotation => {
        let temp = {
          formNo: quotation.formNo,
          comments: quotation.comments,
          highPriceReasonCategory: quotation.highPriceReasonCategory,
          bg: quotation.bg,
          bu: quotation.bu,
          cpcToSupervisorAttachments: quotation.approveReferenceFile
        }
        if (quotation.action === "DELETE") {
          deleteData.push(temp);
        }
        else if (quotation.action === "APPROVE") {
          approveData.push(temp);
        }
      });
      
      if (approveData.length > 0 || deleteData.length > 0) {
        if (approveData.length == 0 || (approveData.length > 0 && checkRequired(approveData, vueInstance))) {
          let data = {
            quotationRequestListForApprove: approveData,
            quotationRequestListForDelete: deleteData
          };
          console.log(data);
          vueInstance.toggleLoading(true);
          vueInstance.$quotationHttp
            .post("/quotation/cpcHighPriceQuotationSubmit", JSON.stringify({
              quotationRequestListForApprove: approveData,
              quotationRequestListForDelete: deleteData
            }))
            .then((response) => {
              vueInstance.toggleLoading(false);
              vueInstance.reload();
            })
            .catch((error) => {
              if (error.response.status == 444) {
                let text = vueInstance.$buildErrorMessage(error)
                vueInstance.$Swal.fire({
                  icon: "error",
                  title: Translate("COMMON_MESSAGE_ERROR"),
                  text,
                })
              }
          });
        }
      }
      else {
        vueInstance.$Swal.fire({
          icon: "info",
          title: vueInstance.$t("COMMON_MESSAGE_INFO"),
          html: "No Select Submit Data",
        });
      }
    },
    stripHtmlTags(str) {
      return str.replace(/<[^>]*>/g, '');
    }
  },
  computed: {
    quotationColumnList() {
      return [
        {
          title: this.$t('ACTION'),
          width: 120,
          align: "center",
          render: (h, params) => {
            if (this.getCpcHighPriceStatus() == "Waiting CPC") {
              let result = [
                h("Radio", {
                  style: {
                    display: "inline-block",
                    "font-size": "14px"
                  },
                  props: {
                    label: "APPROVE",
                  }
                }),
                h("Radio", {
                  style: {
                    display: "inline-block",
                    "font-size": "14px"
                  },
                  props: {
                    label: "DELETE",
                  }
                })
              ]
              let radio =  h("RadioGroup",
                {
                  props: {
                    value: this.quotationList[params.index].action
                  },
                  on: {
                    "on-change": (val) => {
                      this.$set(this.quotationList[params.index], 'action', val);
                    }
                  }
                },
                result
              );
              return h("div", [
                radio, 
                h('button', {
                  class: 'highPriceTableBtn',
                  on: {
                    click: () => {
                      this.$set(this.quotationList[params.index], 'action', '');
                    }
                  }
                }, this.$t('CLEAR'))
              ])
            }
            else {
              return h("a", {}, '');
            }
          }
        },
        {
          title: this.$t('COMMENTS'),
          width: 70,
          align: "center",
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: "ios-create",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.tableCurrItem = structuredClone(this.quotationList[params.index]);
                  if (!this.tableCurrItem.comments) this.tableCurrItem.comments = '';
                  this.tableCommentModel = true;
                },
              },
            })
          }
        },
        {
          renderHeader: (h, params) => {
            return h("div", [
              this.$t("HISTORY"),
              h("br"),
              this.$t("COMMENTS")
            ]);
          },
          width: 70,
          align: "center",
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: "ios-paper",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.toggleLoading(true);
                  this.$queryQuotationLog(this, this.quotationList[params.index].uuid).then(data => {
                    this.toggleLoading(false);
                    this.tableHistoryComment = "";
                    if (data.length > 0) {
                      data.forEach(log => {
                        if (log.quotationRole) {
                          this.tableHistoryComment = this.tableHistoryComment + this.$t('ROLE') + ': ' + log.quotationRole + ', '
                        }
                        if (log.quotationRole) {
                          this.tableHistoryComment = this.tableHistoryComment + this.$t('STATUS') + ': ' + log.flowStatus + ', '
                        }
                        if (log.groupAccount) {
                          this.tableHistoryComment = this.tableHistoryComment + this.$t('GROUP_ACCOUNT') + ': ' + log.groupAccount.code + '/' + log.groupAccount.companyName + ', '
                        }
                        if (log.created) {
                          this.tableHistoryComment = this.tableHistoryComment + this.$t('CREATE_DATE') + ': ' + log.created + ': <br>'
                        }
                        if (log.flowComment) {
                          this.tableHistoryComment = this.tableHistoryComment + log.flowComment
                        }
                        this.tableHistoryComment = this.tableHistoryComment + '<hr style="border:1px dashed #000; height:1px">'
                      });
                    }
                    this.tableHistoryCommentModel = true;
                  }).catch((error) => {
                    AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
                    })
                  })
                },
              },
            })
          }
        },
        {
          renderHeader: (h, params) => {
            return h("div", [
              "Info",
              h("br"),
              "Record"
            ]);
          },
          width: 50,
          align: "center",
          render: (h, params) => {
            return h("div",[
              h('label', (params.row.infoRecordFlag === true) ? ['Yes',
                h('Icon', {
                  props: {
                    type: "md-create",
                    size: 28,
                  },
                  class: "text-delta-blue",
                  on: {
                    click: () => {
                      this.tableCurrItem = structuredClone(this.quotationList[params.index]);
                      this.tableInfoRecordModel = true;
                    },
                  },
                })
              ] : 'No'),
            ])
          }
        },
        {
          renderHeader: (h, params) => {
            return h("div", [
              "Single",
              h("br"),
              "/Cross"
            ]);
          },
          width: 50,
          align: "center",
          render: (h, params) => {
            let content = 'null';
            if (this.quotationList[params.index]?.orgCheck === 'C') {
              content = 'Cross';
            }
            else if (this.quotationList[params.index]?.orgCheck === 'S') {
              content = 'Single';
            }
            return h("a", {}, content);
          }
        },
        {
          renderHeader: (h, params) => {
            return h("div", [
              this.$t("HIGH_PRICE"),
              h("br"),
              this.$t("REASON_CATEGORY")
            ]);
          },
          width: 100,
          align: "center",
          render: (h, params) => {
            let data = this.quotationList[params.index];
            if (data.editable === false) {
              return h("a", {}, data.highPriceReasonCategory);
            }
            else {
              return h('Select', {
                props: {
                  value: this.quotationList[params.index].highPriceReasonCategory,
                  transfer: true
                },
                on: {
                  'on-change': (value) => {
                    this.quotationList[params.index].highPriceReasonCategory = value;
                  }
                },
              },[
                this.highPriceReasonCategoryList.map(option => 
                  h('Option', {
                    props: {
                      value: option.highPriceReasonCategory,
                    }
                  }, option.highPriceReasonCategory)
                )
              ])
            }
          }
        },
        {
          title: this.$t('DIFF'),
          width: 50,
          align: "center",
          render: (h, params) => {
            let diff = this.quotationList[params.index]['priceDiff'];
            return h("a", {}, (diff ? diff + '%' : ''));
          }
        },
        {
          title: "BG",
          width: 100,
          align: "center",
          render: (h, params) => {
            let data = this.quotationList[params.index];
            if (data?.editable === false) {
              return h("a", {}, data.bg);
            }
            else {
              return h('Select', {
                props: {
                  value: this.quotationList[params.index].bg,
                  transfer: true
                },
                on: {
                  'on-change': (value) => {
                    this.quotationList[params.index].bg = value;
                    this.quotationList[params.index].bu = '';
                  }
                },
              },[
                this.bgList.map(option => 
                  h('Option', {
                    props: {
                      value: option,
                    }
                  }, option)
                )
              ])
            }
          }
        },
        {
          title: "BU",
          width: 100,
          align: "center",
          render: (h, params) => {
            let data = this.quotationList[params.index];
            if (data?.editable === false) {
              return h("a", {}, data.bu);
            }
            else {
              return h('Select', {
                props: {
                  value: this.quotationList[params.index].bu,
                  transfer: true
                },
                on: {
                  'on-change': (value) => {
                    this.quotationList[params.index].bu = value;
                  }
                },
              },[
                this.bgbuMap[this.quotationList[params.index].bg]?.map(option => 
                  h('Option', {
                    props: {
                      value: option,
                    }
                  }, option)
                )
              ])
            }
            
          }
        },
        {
          title: this.$t('Plant'),
          key: "plant",
          width: 50,
          align: "center",
        },
        {
          title: this.$t('DELTA_PN'),
          key: "partNo",
          width: 100,
          align: "center",
        },
        {
          title: this.$t('PART_DESCRIPTION'),
          key: "partDescription",
          width: 100,
          align: "center",
        },
        {
          title: this.$t('VENDOR_PART'),
          key: "vendorPart",
          width: 150,
          align: "center",
        },
        {
          title: this.$t('VN_CODE'),
          key: "vnCode",
          width: 80,
          align: "center",
        },
        {
          title: this.$t('VN_NAME'),
          key: "vnName",
          width: 100,
          align: "center",
        },
        {
          title: this.$t('AGENT'),
          key: "agent",
          width: 80,
          align: "center",
        },
        {
          title: this.$t('AGENT_NAME'),
          key: "agentName",
          width: 100,
          align: "center",
        },
        {
          title: this.$t('UNIT_PRICE'),
          key: "unitPrice",
          width: 70,
          align: "center",
        },
        {
          title: this.$t('CURRENCY'),
          key: "currency",
          width: 70,
          align: "center",
        },
        {
          title: this.$t('LOG'),
          width: 50,
          align: "center",
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: "ios-paper",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.tableLogModel = true;
                  this.tableLogList = []
                  this.toggleLoading(true)
                  this.$queryQuotationLog(this, params.row.uuid).then(data => {
                    this.toggleLoading(false)
                    this.tableLogList = data ? data : [];
                    console.log(this.tableLogList);
                  })
                },
              },
            })
          }
        },
        {
          title: this.$t('ITEM_CATEGORY'),
          key: "itemCategory",
          width: 100,
          align: "center",
        },
        {
          title: this.$t('VALID_FROM'),
          key: "validFrom",
          width: 70,
          align: "center",
        },
        {
          title: this.$t('VALID_TO'),
          key: "validTo",
          width: 70,
          align: "center",
        },
        {
          title: this.$t('QUOTATION_FILE'),
          width: 55,
          align: "center",
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: params.row["quotationFile"] && params.row["quotationFile"].length > 0 ? "ios-cloud-download" : "",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.tableQuotationFile = [];
                  this.tableQuotationFile = params.row.quotationFile;
                  this.tableQuotationFileModel = true;
                },
              },
            })
          }
        },
        {
          title: this.$t('REFERENCE_FILE'),
          width: 55,
          align: "center",
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: "md-cloud-upload",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.file = null;
                  this.tableReferenceFile = [];
                  this.tableReferenceFile = this.quotationList[params.index].approveReferenceFile ? this.quotationList[params.index].approveReferenceFile.filter(attachment => !attachment.deleted) : []
                  this.tableCurrItem = structuredClone(this.quotationList[params.index]);
                  this.tableReferenceFileModel = true;
                },
              },
            })
          }
        },
        {
          title: this.$t('APPLY_DATE'),
          key: "applyDate",
          width: 70,
          align: "center",
        },
        {
          title: this.$t('FORM_NO'),
          key: "formNo",
          width: 150,
          align: "center",
        },
      ]
    },
    tableLogColumnList() {
      return [
        {
          title: this.$t('ROLE'),
          width: 150,
          align: "center",
          render: (h, params) => {
            return h("div", {}, params.row.quotationRole)
          }
        },
        {
          title: this.$t('STATUS'),
          width: 150,
          align: "center",
          render: (h, params) => {
            return h("div", {}, params.row.flowStatus)
          }
        },
        {
          title: 'Sequence',
          width: 180,
          align: "center",
          render: (h, params) => {
            return h("div", {}, params.row.sequence)
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('GROUP_ACCOUNT');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "groupAccount",
          width: 180,
          align: "center",
          render: (h, params) => {
            return h("span", {}, params.row["groupAccount"].companyName)
          }
        },
        {
          title: this.$t('ACTION'),
          width: 180,
          align: "center",
          render: (h, params) => {
            return h("div", {}, params.row.flowAction)
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('COMMENTS');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 150,
          align: "center",
          render: (h, params) => {
            if (params.row.flowComment) {
              return h("Icon", {
                props: {
                  type: "ios-paper",
                  size: 28,
                },
                class: "text-delta-blue",
                on: {
                  click: () => {
                    this.flowComment = params.row.flowComment
                    this.flowCommentModel = true
                  },
                },
              })
            } else {
              return h("span", {}, "")
            }
            // return h("div", {}, params.row.flowComment)
          }
        },
        {
          title: this.$t('CREATE_DATE'),
          width: 180,
          align: "center",
          render: (h, params) => {
            return h("div", {}, params.row.created)
          }
        },
        {
          title: this.$t('PERSON_ACCOUNT'),
          width: 200,
          align: "center",
          render: (h, params) => {
            return h("div", {}, params.row.personEmail)
          }
        },
      ]
    },
    quotationView() {
      return this.quotationList && this.quotationList.length > 0
    },
    showBatchApproveReferenceFile() {
      return this.batchApproveReferenceFile.filter(attachment => !attachment.deleted);
    },
    showApproveReferenceFile() {
      return this.approveReferenceFile.filter(attachment => !attachment.deleted);
    },
    status: {
      get() {
        return this.getCpcHighPriceStatus()
      },
      set(value) {
        this.quotationList = []
        this.quotationGroupList = []
        this.setCpcHighPriceStatusEnum(this.statusList.find(status => status.description == value))
        return this.setCpcHighPriceStatus(value)
      }
    },
    deltaPn: {
      get() {
        return this.getCpcHighPriceDeltaPn()
      },
      set(value) {
        this.quotationList = []
        this.quotationGroupList = []
        return this.setCpcHighPriceDeltaPn(value.trim())
      }
    },
    vnCode: {
      get() {
        return this.getCpcHighPriceVendorCode()
      },
      set(value) {
        this.quotationList = []
        this.quotationGroupList = []
        return this.setCpcHighPriceVendorCode(value.trim())
      }
    },
    fromRfqDate: {
      get() {
        return this.getCpcHighPriceFromRfqDate()
      },
      set(value) {
        this.quotationList = []
        this.quotationGroupList = []
        return this.setCpcHighPriceFromRfqDate(value)
      }
    },
    toRfqDate: {
      get() {
        return this.getCpcHighPriceToRfqDate()
      },
      set(value) {
        this.quotationList = []
        this.quotationGroupList = []
        return this.setCpcHighPriceToRfqDate(value)
      }
    },
    plant: {
      get() {
        return this.getCpcHighPricePlant()
      },
      set(value) {
        this.quotationList = []
        this.quotationGroupList = []
        return this.setCpcHighPricePlant(value)
      }
    },
    modalSize() {
      return this.getModalSize()
    },
    windowWidth() {
      return this.getWindowsWidth() - 50
    }
  },
  watch: {
    // 監聽 selectAllType 批次修改 Action
    selectAllType(value) {
      const vueInstance = this; 
      vueInstance.quotationList.forEach(quotation => {
        vueInstance.$set(quotation, 'action', value);
      });
    },
    // 監聽 bg 批次修改
    bg(value) {
      const vueInstance = this; 
      vueInstance.bu = '';
      vueInstance.quotationList.forEach(quotation => {
        if (quotation.editable) {
          vueInstance.$set(quotation, 'bg', value);
          vueInstance.$set(quotation, 'bu', '');
        }
      });
    },
    bu(value) {
      const vueInstance = this; 
      vueInstance.quotationList.forEach(quotation => {
        if (quotation.editable) {
          vueInstance.$set(quotation, 'bg', vueInstance.bg);
          vueInstance.$set(quotation, 'bu', value);
        }
      }); ``
    },
    highPriceReasonCategory(value) {
      const vueInstance = this;
      vueInstance.quotationList.forEach(quotation => {
        if (quotation.editable) {
          vueInstance.$set(quotation, 'highPriceReasonCategory', value);
        }
      });
    },
  },
}

function query(vueInstance, queryData) {
  return vueInstance.$queryHighPriceQuotationMaster(vueInstance, queryData, "quotation", vueInstance.pageObj)
}

function buildCriteria(vueInstance) {
  let deltaPnArray = []
  vueInstance.getCpcHighPriceDeltaPn().split(';').forEach(a => {
    deltaPnArray.push(a)
  })

  let vnCodeArray = []
  vueInstance.getCpcHighPriceVendorCode().split(';').forEach(a => {
    vnCodeArray.push(a)
  })

  let plantArray = []
  vueInstance.getCpcHighPricePlant().split(';').forEach(a => {
    plantArray.push(a)
  })

  return {
    "deltaPartNos": vueInstance.getCpcHighPriceDeltaPn() == "" ? [] : deltaPnArray,
    "status": vueInstance.statusList.find(status => status.description == vueInstance.getCpcHighPriceStatus())['statusViewEnum'],
    "vendorCodes": vueInstance.getCpcHighPriceVendorCode() == "" ? [] : vnCodeArray,
    "fromRfqDate": vueInstance.getCpcHighPriceFromRfqDate() == "" ? null : moment(vueInstance.getCpcHighPriceFromRfqDate()).format('YYYY-MM-DD'),
    "toRfqDate": vueInstance.getCpcHighPriceToRfqDate() == "" ? null : moment(vueInstance.getCpcHighPriceToRfqDate()).format('YYYY-MM-DD'),
    "plantNos": vueInstance.getCpcHighPricePlant() == "" ? [] : plantArray
  }
}

function checkRequired(approveData, vueInstance) {
  let errorMessage = ""
  approveData.forEach(quotation => {
    if (!quotation.bg) {
      errorMessage = errorMessage + quotation.formNo + ": " + vueInstance.$t('BG') + vueInstance.$t('IS_REQUIRED') + " <br>"
    }
    if (!quotation.bu) {
      errorMessage = errorMessage + quotation.formNo + ": " + vueInstance.$t('BU') + vueInstance.$t('IS_REQUIRED') + " <br>"
    }
    if (!quotation.highPriceReasonCategory) {
      errorMessage = errorMessage + quotation.formNo + ": " + vueInstance.$t('HIGH_PRICE_REASON_CATEGORY') + vueInstance.$t('IS_REQUIRED') + " <br>"
    }
    if (quotation.quotationHighPrice?.attachmentRequired === 1) {
      if (!quotation.cpcToSupervisorAttachments) {
        errorMessage = errorMessage + quotation.formNo + ": " + vueInstance.$t('HIGH_PRICE_ATTACHMENT_REQUIRED') + " <br>"
      }
    }
  })
  if (errorMessage) {
    vueInstance.toggleLoading(false)
    AlertInfo(vueInstance, errorMessage).then(() => {
    })
  }
  return errorMessage == "";
}

</script>

<style scoped>
.select-small {
  width: 120px;
}
.button {
  width: auto;
}
.editBtn {
  width: auto;
  padding: 0 8px;
}
.editBtn i {
  color: white;
  font-size: 16px;
}
.mr-10 {
  margin-right: 10px;
}

</style>

<style>
.highPriceTableBtn {
  padding: 5px 15px;
  border: 1px solid #2db7f5;
  background-color: white;
  border-radius: 3px;
  cursor: pointer;
  width: 60px;
}
.highPriceTableBtn:hover {
  background-color: #2db7f5;
  color: white;
}

.highPriceTable input[type="radio"] {
  vertical-align: text-bottom;
  margin-right: 5px;
}
.highPriceTable .radioContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0;
}
</style>